import localeFr from './fr'
import localeEn from './en'

const messages = {
  en: localeEn,
  fr: localeFr
}

export default messages
